import React, { useState } from 'react';

import classNames from 'classnames';
import ReactPlayer from 'react-player';
import { useTranslation } from 'react-i18next';

import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import ButtonWrapper from '../../../../components/ButtonWrapper';
import DynamicMediaItem from '../../../../components/DynamicMediaItem';

import './style.scss';

const HighlightedCampaign = ({ entity, className }: { entity: any, className: string }) => {
  const [buttonClicked, setButtonClicked] = useState(false);
  const { t } = useTranslation();

  const buttonClass = classNames({
    hidden: buttonClicked,
  });

  let bodyText = entity.field_body[0]!.value!.slice(0, 180);

  if (entity.field_body[0]!.value!.length > 180) {
    bodyText += '...';
  }

  return (
    <div className={className}>
      <div className="HighlightedCampaign">
        <div className="HighlightedCampaign__media">
          {
            entity.field_media[0]!.entity!.bundle[0]!.target_id === 'video' ? (
              <>
                <div className="HighlightedCampaign__media__buttonWrapper">
                  <ButtonWrapper classNames={buttonClass} type="primary" onClick={() => { setButtonClicked(true); }}>
                    {t('button.watch_video')}
                    <i className="icon icon-play" />
                  </ButtonWrapper>
                </div>
                <ReactPlayer className="HighlightedCampaign__media__video" url={entity.field_media[0]!.source} controls playing={buttonClicked} width="100%" height="100%" />
              </>
            ) : (
              <DynamicMediaItem
                media={entity.field_media[0]}
              />
            )
          }
        </div>
        <div className="HighlightedCampaign__info">
          <h2>
            {entity.field_title[0]!.value}
          </h2>
          <div className="HighlightedCampaign__info__bodyWrapper">
            <div className="HighlightedCampaign__info__body">
              <WysiwygField html={bodyText} />
            </div>
            <ButtonWrapper
              type="secondary"
              href={entity.field_link[0]!.uri}
            >
              {entity.field_link[0]!.title}
            </ButtonWrapper>

          </div>
        </div>
      </div>
    </div>
  );
};

export default HighlightedCampaign;
